import { render, staticRenderFns } from "./peugeot.vue?vue&type=template&id=6e1ffb8d&"
import script from "./peugeot.vue?vue&type=script&lang=js&"
export * from "./peugeot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports